import { useVerticalSignPole } from "./useVerticalSignPoles"
import { useVerticalSignTypeQueries } from "./useVerticalSignTypes"

export function usePoleWithVerticalSigns(poleId, parameters = {}, config = {}) {

    const {
        data: poleData,
        isError: poleError,
        isLoading: poleLoading,
    } = useVerticalSignPole(poleId, parameters, config)

    const queriesData = useVerticalSignTypeQueries((!poleData?.vertical_signs ? [] : poleData.vertical_signs))
    const isError = poleError || queriesData.some(queryData => queryData.error)
    const isLoading = poleLoading || queriesData.some(queryData => queryData.isLoading)

    const data = (isLoading || isError) ? null : {
        ...poleData,
        vertical_signs: poleData.vertical_signs.map(verticalSign => ({
            ...verticalSign,
            ...queriesData
                .find(query => {
                    return query.data.code === verticalSign.vertical_sign_type
                }).data,
        })),
    }

    return {
        data,
        isError,
        isLoading,
    }
}